import { ResolveSwapOrReturnTable } from './ResolveSwapOrReturnTable'

export default ResolveSwapOrReturnTable
